import React from 'react'

import { STEP_CONST } from '@constants/demoSaleApplication/constant'
import { DemoSellAlert } from '@zet/common/components/demoSellAlert'
import { B1, B2, Button, Input, InputGroup, Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { LeadStatus } from '@zet/utils/Constants'
import { getLoginHash } from '@zet/utils/loginHash'

import KeyBoardWrapper from '@components/keyboardWrapper'

import { useNavigation } from '@hooks/useNavigation'

import {
  useGetDemoLeadDetails,
  useSetDemoLeadStatus,
} from '../../../../api/webflow/demoSale/hooks'
import { useDemoSaleApplicationState } from '../../../../store/demoSaleApplicationState'
import { TestBrandApplicationHeader } from '../../../components/testBrancApplicationHeader'

export const EnterNameAndPan = () => {
  const { setCurrentState } = useDemoSaleApplicationState((state) => state)
  const { navigate } = useNavigation()
  const hash = getLoginHash()

  const { data } = useGetDemoLeadDetails()
  const { mutate } = useSetDemoLeadStatus()

  function handlePress() {
    mutate(
      { status: LeadStatus.ACTION_REQUIRED },
      {
        onSuccess() {
          setCurrentState(STEP_CONST.EKYC)
          navigate('LeadApplicationStatus', { hash })
        },
        onError(e) {
          console.log(e)
        },
      }
    )
  }
  return (
    <KeyBoardWrapper
      className="flex-1 bg-white "
      BottomSheet={
        <Button onPress={handlePress} className="my-4/2 mx-3">
          {i18n.t('demoSale.submit')}
        </Button>
      }
    >
      <Stack>
        <TestBrandApplicationHeader
          header={i18n.t('demoSale.enterNumberAndPan.header')}
        />
        <DemoSellAlert content={i18n.t('demoSale.leadFuFilled.info')} />
        <Stack className="mx-3">
          <Stack className="mb-1 mt-3">
            <B2 className="text-grays-80">
              {i18n.t('knowCustomer.customerPhNum')}
              <B1 className="text-error-100 ml-1">*</B1>
            </B2>
            <InputGroup
              placeholder="9000000000"
              value={data?.customerDetails?.phoneNumber}
              size="md"
              maxLength={10}
              keyboardType="number-pad"
              editable={false}
            />
          </Stack>
          <Stack className="mb-1 mt-3">
            <B2 className="text-grays-80">
              {i18n.t('webFlow.basicDetails.pan')}
              <B1 className="text-error-100 ml-1">*</B1>
            </B2>
            <Input
              placeholder="Eg: XXXXXXXXXX"
              value={'XXXXXXXXXX'}
              className="mt-1 "
              editable={false}
            />
          </Stack>
        </Stack>
      </Stack>
    </KeyBoardWrapper>
  )
}
